import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import VendorRelationTable from './vendor_relation_table';

export default function QuickbooksUserVendorTable({ users, usersCount }) {
  const showTableByDefault = users.some(u => u.quickbooksId);
  const [showTable, setShowTable] = useState(showTableByDefault);

  // `users` holds only the already-linked users (the rows). The full non-broker list is loaded on
  // demand by the picker, so `usersCount` — the total count — tells us whether there's anything to add.
  if (usersCount === 0) {
    return null;
  }

  if (!showTable) {
    return (
      <AddControl id="add-vendor-associations" onClick={() => setShowTable(true)}>
        Add Associations
      </AddControl>
    );
  }

  return (
    <VendorRelationTable
      relationType="User"
      showAll={false}
      users={users}
      usersCount={usersCount}
      vendorFetchType="user"
    />
  );
}

QuickbooksUserVendorTable.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    quickbooksId: PropTypes.number,
  })).isRequired,
  // Total number of non-broker users (linked + unlinked); the linked ones arrive via `users`.
  usersCount: PropTypes.number.isRequired,
};
